import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { MicrosoftOAuthContext } from './context';

/**
 * MicrosoftOAuthProvider component that provides Microsoft OAuth context to its children.
 *
 * @component
 * @param {Object} props - The component properties.
 * @param {string} props.clientId - The Microsoft client ID for OAuth.
 * @param {React.ReactNode} props.children - The children to be wrapped by the provider.
 * @returns {JSX.Element} The MicrosoftOAuthContext provider wrapping the children.
 */
export default function MicrosoftOAuthProvider({
	clientId,
	children,
}) {
	const contextValue = useMemo(() => ({
		clientId,
	}), [clientId]);

	return (
		<MicrosoftOAuthContext.Provider value={contextValue}>
			{children}
		</MicrosoftOAuthContext.Provider>
	);
}

MicrosoftOAuthProvider.propTypes = {
	clientId: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
};
